export const Translations = {
  en: {
    // validation
    Validation: {
      required: '{field} is required.',
      min: {
        string: '{field} must be at least {min} characters.',
        numeric: '{field} must be at least {min}'
      },
      max: {
        string: '{field} must not be greater that {max} characters.',
        numeric: '{field} must not be greater that {max}.'
      },
      numeric: '{field} must be a number.',
      email: '{field} must be an email.',
      digits_between: '{field} must be between {min} and {max} digits.',
      between: {
        string: '{field} must be between {min} and {max} characters.',
        numeric: '{field} must be between {min} and {max}.'
      }
    },
    // header
    Home: 'Home',
    Products: 'Products',
    TermsOfService: 'Terms of Service',
    PrivacyPolicy: 'Privacy Policy',
    ShippingAndReturn: 'Shipping and Return',
    FAQ: 'FAQ',
    Contact: 'Contact',
    ContactUs: 'Contact us',
    About: 'About us',
    Refund: 'Refund Policy',
    // AboutUsContent: aboutContentEn,
    // RefundContent: refundPolicyEn,
    FaqContent: [{
      FaqQuestion: 'HOW CAN I FOLLOW MY ORDERS AND PAYMENTS?',
      FaqAnswer: 'We will send tracking number by email right after shipping your order.'
    }, {
      FaqQuestion: 'WHAT IF I NEED TO RETURN THE PRODUCT?',
      FaqAnswer: 'Do not worry! Contact us as soon as possible in the first 7 days of receiving your order, and we will help you process the return and the refund or exchange.'
    }, {
      FaqQuestion: 'HOW LONG DOES IT TAKE TO GET MY ORDER?',
      FaqAnswer: 'Your order will be delivered within 5-8 days of order confirmation, depending on the volume of orders received.<br>' + 'If there is any delay in receiving your order, please contact us  and we will help you confirm the status of your order.'
    }, {
      FaqQuestion: 'WHAT PAYMENT POSSIBILITIES ARE HERE?',
      FaqAnswer: ' You can pay by card online. The transaction is 100% secure, and we don\'t save your card info.'
    }, {
      FaqQuestion: 'WHAT HAPPENS IF MY DELIVERY IS DAMAGED OR LOST?',
      FaqAnswer: 'We take these issues very seriously and we will deal with them on ' + 'a case-by-case basis. For more information on our exchange and refund policy, please <a class="font-weight-bold" href="shipping-return-policy">click here</a>.'
    }],
    LegalPages: 'Legal pages',
    Informations: 'Informations',
    HomePageMain: {
      FirstLine: 'Amazing online shopping experience!',
      Bullets: {
        BulletOne: 'High quality products',
        BulletTwo: 'Incredible discounts',
        BulletThree: 'Fast delivery times'
      },
      SecondLine: 'Don’t hesitate! You will love our products',
      ShopNowBtn: 'Shop now'
    },
    NoOfferInYourCountry: 'Sorry! No offers in {country} yet',
    HomePageAboutUs: {
      Title: 'ABOUT US',
      Content: '{store_name} is an online store in {country_name} specializing in innovative products and accessories that will make your daily life easier and a lot more fun.' + 'We try our best to provide quality support, and faster shipping times to our customers. We promise to process your orders in less than 24h, and to answer all your questions on time.' + 'We are happy to welcome you in our store, fell free to place orders any time :) Your satisfaction is our Goal.'
    },
    HomePageAmazingDelivery: {
      Title: 'Amazing delivery experience',
      Content: 'You can place your order in our store with peace of mind, we partnered with the best couriers in {country} to provide you with fast delivery time of 2 to 5 days, and safe payment method by cash on delivery.\n'
    },
    HomePageSatisfaction: {
      Title: '100% Satisfaction Guarantee',
      Content: {
        Text: 'We offer free shipping on all products, and we give you 30 days of guarantee.',
        Figures: {
          FigureOne: 'Free Shipping',
          FigureTwo: 'Trusted Site',
          FigureThree: 'Secure Checkout',
          FigureFour: 'Fast Customer Support'
        }
      }
    },
    HomePageDoYouHaveQuestion: {
      Title: 'Do you have other questions?',
      Content: 'Visit the contact page, and send us your message. We try our best to answer all our customers in less than 24h'
    },
    HomePageFooter: {
      PaymentByCash: 'Payment by Cash on Delivery',
      FreeShipping: 'Free Shipping, and Fast Delivery <span class="font-weight-bold" style="white-space: nowrap">( 5 to 8 days )</span>',
      SecurePayment: 'Secure payment'
    },
    DiscoverOurProducts: 'Discover our products',
    // footer
    CopyRight: 'Copyright © 2020-{current_year} {brand_name}. All Rights Reserved.',
    StepOne: 'Step 1:',
    SelectQuantity: 'Select quantity',
    TotalPrice: 'Total Price',
    StepTwo: 'Step 2:',
    StepThree: 'Step 3:',
    StepThreeText: 'Payment info',
    DeliveryInfo: 'Delivery info in <strong>{country}</strong>',
    HowManyUnits: {
      title: 'To order, please add your info.',
      subtitle: 'Buy more to Save more !'
    },
    OrderForm: {
      title: 'Card',
      FullName: 'Name',
      Mobile: 'Mobile',
      Address: 'Address',
      CardNumber: {
        title: 'Card number',
        placeholder: '1234 1234 1234 1234'
      },
      CardExpiry: {
        title: 'Exp date',
        placeholder: 'YY / MM'
      },
      CardCvc: {
        title: 'CVC',
        placeholder: 'CVC'
      },
      Country: 'Country',
      PostalCode: 'Code Postal',
      City: 'City',
      CustomCity: 'Custom City',
      Region: {
        title: 'Region',
        select: 'Select your region'
      },
      CustomRegion: {
        title: 'Custom Region',
        select: 'Select your custom region'
      },
      Email: 'Email (optional)'
    },
    Qt: 'Quantity',
    // terms of service
    TermOfServiceSubTitle: 'please read our terms of service here.',
    // TermOfServiceContent: termsOfServiceEn,
    PrivacyPolicySubTitle: 'your privacy is our concern please read our privacy policy here.',
    /*PrivacyPolicyContent: privacyPolicyEn,*/
    ShippingAndReturnSubTitle: 'if you have a product you want to return or know about our shipping procedure, please read our policy here.',
    // ShippingAndReturnContent: returnAndShipContentEn,
    //contact us
    ContactSubtitle: 'We try our best to answer all our customers in less than 24h. ' + 'If you have any questions please contact us from this form. Or you can send us email to: <strong>{domain}</strong> ' + 'If you are contacting us about your order, please mention your order number or the full name of the buyer in your message.',
    ContactForm: {
      Name: 'Name',
      Subject: 'Subject',
      Email: 'Email',
      Content: 'Content'
    },
    SendBtn: 'Send',
    UpsellAttention: 'ATTENTION: This is a one time offer!',
    SpecialOffer: 'Special Offer',
    UpsellP1: '<strong>{discount} discount to our new customers<strong>',
    UpsellP2: 'We have received your order and we want to thank you and welcome you for being a new customer.',
    UpsellP3: 'We offer a generous <strong>{discount}</strong> discount to our new customers',
    UpsellP4: 'If you add another <strong>{offerName}</strong> to your order you can get it at <strong>{discount} discount</strong>',
    UpsellP5: 'The price of additional <strong>{offerName}</strong> is only <strong>{offerSalePrice} {offerSalePricePrefix}</strong> You can add 1 or more to your order at this price',
    UpsellP6: '<strong>Can you accept this special offer ?</strong>',
    Price: 'Price',
    YesConfirm: 'YES! Add to my order',
    NoConfirm: 'No, Im not interested',
    PayOnDelivery: 'Pay by Cash On Delivery',
    CrossSellP1: '<strong>{discount} discount to our new customers</strong>',
    CrossSellP2: 'We have received your order and we want <strong>to suggest another product</strong> ' + 'that could be also <strong>very interesting</strong> to you at this <strong>discounted price</strong>.',
    CrossSellP3: '<strong>We offer a generous {discount} discount to our new customers</strong>',
    CrossSellP4: 'If you add <strong>{offerName}</strong> to your order you can get it at <strong>{discount} discount</strong>',
    CrossSellP5: 'The discounted price of <strong>{offerName}</strong> is only <strong>{salePrice} {currency}</strong> You can add 1 or more to your order at this price',
    CrossSellP6: '<strong>Can you accept this special offer ?</strong>',
    WhatHowItWorks: 'What Is it And How Does It Work ?',
    UpsellWarrantyP1: '<strong>Get 1 Year extended guarantee</strong>',
    UpsellWarrantyP2: 'Our products are covered by <strong>30 days money back guarantee</strong>, but you can now extend it to <strong>1 year guarantee</strong>.',
    UpsellWarrantyP3: 'If the product stop working we will send you a new one for free!',
    UpsellWarrantyP4: '<strong>Get peace of mind by extending your guarantee</strong>',
    UpsellWarrantyP5: 'The price of 1 year guarantee is only <strong>{salePrice} {currency}</strong>',
    UpsellWarrantyP6: '<strong>Can you accept this special offer?</strong>',
    ThankYou: 'Thank you',
    ThankYouP1: '<strong>We have received your order, and here are your purchased products</strong>',
    PurchasedItems: '<strong>Purchased items</strong>',
    Total: '<strong>Total</strong>',
    MissingInfoText: 'If your delivery info is missing some information, you can correct it now',
    SaveConfirm: 'Save & confirm',
    OrderCongratulation: 'Congratulations! we have saved you information, we will call you very soon to confirm you order',
    AboutOrderShipping: 'Before shipping your order, we will call you today or tomorrow to confirm your delivery, please make sure your mobile phone number is correct.',
    DeliveryTime: 'Delivery time: 2 to 5 days, Payment by Cash On Delivery',
    ProductImage: 'Product image',
    ProductName: 'Product name',
    OrderNow: 'Order Now',
    PayByCashOnDelivery: 'Pay by Cash On Delivery',
    NoOfferInDomain: 'Sorry! No offers in this domain',
    CheckoutValidationError: 'Please complete your info.',
    WhatsUpHiMessage: 'Hi, please tell me more about : {page_name} : {page_url}'
  },
  fr: {
    // validation
    Validation: {
      required: '{field} est obligatoire.',
      min: {
        string: '{field} doit contenir au moins :min caractères.',
        numeric: 'La valeur de {field} doit être inférieure à {min}.'
      },
      max: {
        string: '{field} must not be greater that {max} characters.',
        numeric: 'La valeur de {field} ne peut être supérieure à {max}.'
      },
      numeric: '{field} doit contenir un nombre.',
      email: 'Le format du {field} est invalide.',
      digits_between: '{field} doit avoir entre {min} and {max} chiffres.',
      between: {
        string: '{field} doit avoir entre :min et {max} caractères.',
        numeric: '{field} doit être comprise entre {min} et {max}.'
      }
    },
    // header
    Home: 'Accueil',
    Products: 'produits',
    TermsOfService: 'Conditions d’utilisation',
    PrivacyPolicy: 'Politique de confidentialité',
    ShippingAndReturn: 'Expédition et retour',
    FAQ: 'FAQ',
    About: 'À Propos',
    Contact: 'Contact',
    ContactUs: 'Contactez-nous',
    Refund: 'Remboursement',
    // AboutUsContent: aboutContentFr,
    // RefundContent: refundPolicyFr,
    // ShippingAndReturnContent: returnAndShipContentFr,
    // TermOfServiceContent: termsOfServiceFr,
    FaqContent: [{
      FaqQuestion: 'COMMENT SUIVRE MES COMMANDES ET PAIEMENTS ?﻿',
      FaqAnswer: 'Nous vous enverrons le numéro de suivi par e-mail juste après l\'expédition de votre commande.'
    }, {
      FaqQuestion: 'ET SI J\'AI BESOIN DE RETOURNER LE PRODUIT ?﻿',
      FaqAnswer: 'Ne vous inquiétez pas ! Contactez-nous dès que possible dans les 7 premiers jours suivant la ' + 'réception de votre commande, et nous vous aiderons à traiter le retour et le remboursement ou l\'échange.'
    }, {
      FaqQuestion: 'COMBIEN DE TEMPS FAUT-IL POUR OBTENIR MA COMMANDE ?﻿',
      FaqAnswer: 'Votre commande sera livrée dans les 5-8 jours suivant la confirmation de la commande, en fonction du volume de commandes reçues.<br>' + 'En cas de retard dans la réception de votre commande, veuillez nous contacter et nous vous aiderons à confirmer l\'état de votre commande.'
    }, {
      FaqQuestion: 'QUELLES POSSIBILITÉS DE PAIEMENT ?',
      FaqAnswer: 'Vous pouvez payer par carte en ligne. La transaction est 100% sécurisée et nous ne sauvegardons pas les informations de votre carte.'
    }, {
      FaqQuestion: 'QUE SE PASSE-T-IL SI MA LIVRAISON EST ENDOMMAGÉE OU PERDUE ?﻿',
      FaqAnswer: 'Nous prenons ces problèmes très au sérieux et nous les traiterons au cas par cas. ' + 'Pour plus d\'informations sur notre politique d\'échange et de remboursement, veuillez ' + '<a class="font-weight-bold" href="shipping-return-policy">cliquer ici</a>.'
    }],
    LegalPages: 'Pages légales',
    Informations: 'Informations',
    HomePageMain: {
      FirstLine: 'Expérience d’achat en ligne incroyable!',
      Bullets: {
        BulletOne: 'Produits de haute qualité',
        BulletTwo: 'Des remises incroyables',
        BulletThree: 'Délais de livraison rapides'
      },
      SecondLine: 'N\'hésitez pas ! Vous allez adorer nos produits',
      ShopNowBtn: 'Découvrez nos promos'
    },
    NoOfferInYourCountry: 'Bientôt des produits pour {country}',
    HomePageAboutUs: {
      Title: 'À PROPOS DE NOUS',
      Content: '{store_name} est une boutique en ligne en {country_name} spécialisée dans les produits et accessoires innovants qui rendront votre quotidien plus facile et beaucoup plus amusant.' + 'On fait de notre mieux pour fournir un support de qualité et des délais de livraison plus rapides à nos clients. Nous nous engageons à traiter vos commandes en moins de 24h, et à répondre à toutes vos questions à temps.' + 'Nous sommes heureux de vous accueillir dans notre magasin, n\'hésitez pas à passer des commandes à tout moment :) Votre satisfaction est notre priorité.'
    },
    HomePageAmazingDelivery: {
      Title: 'Expérience de livraison satisfaisante',
      Content: 'Vous pouvez passer votre commande sur notre site en toute tranquillité, nous nous sommes associés aux meilleurs ' + 'coursiers du pays pour vous offrir un délai de livraison rapide de 2 à 5 jours et un mode de paiement sécurisé par contre-remboursement  à la livraison.\n'
    },
    HomePageSatisfaction: {
      Title: 'Garantie de satisfaction à 100 %',
      Content: {
        Text: 'On vous offre la livraison gratuite sur tous les produits, et une garantie de 30 jours pour tester tranquillement votre achat.',
        Figures: {
          FigureOne: 'Livraison gratuite',
          FigureTwo: 'Site de confiance',
          FigureThree: 'Paiement sécurisé',
          FigureFour: 'Support client rapide'
        }
      }
    },
    HomePageDoYouHaveQuestion: {
      Title: 'Vous avez d\'autres questions?',
      Content: 'Rendez-vous sur la page contact, et envoyez-nous votre message. Nous faisons de notre mieux pour répondre à tous nos clients en moins de 24h\n'
    },
    HomePageFooter: {
      PaymentByCash: 'Paiement en espèces à la livraison',
      FreeShipping: '<strong>livraison gratuite et rapide <span class="font-weight-bold" style="white-space: nowrap">( 2 à 5 jours )</span><strong>',
      SecurePayment: 'Paiement sécurisé'
    },
    DiscoverOurProducts: 'Découvrez nos produits',
    // footer
    CopyRight: 'Copyright © 2020-2021 {brand_name}.</br> Tous droits réservés',
    FooterDesc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur consequatur impedit incidunt ipsam " + "molestias repellat repellendus sequi tempora. Asperiores beatae consectetur delectus eius error eveniet " + "explicabo, fugiat illo ipsa, minus molestiae non pariatur quasi quo ullam voluptatem voluptates? Ad adipisci" + "consequuntur debitis eaque eveniet ex molestias, odio sapiente! In, quaerat.",
    StepOne: 'Étape 1:',
    SelectQuantity: 'Sélectionner la quantité',
    TotalPrice: 'Prix total',
    StepTwo: 'Étape 2:',
    StepThree: 'Étape 3:',
    StepThreeText: 'Information de paiement',
    DeliveryInfo: 'Informations de livraison <strong>{country}</strong>',
    HowManyUnits: {
      title: 'Pour commander, veuillez ajouter vos informations.',
      subtitle: 'Acheter plus pour Économiser plus!'
    },
    OrderForm: {
      title: 'Carte',
      FullName: 'Nom',
      Mobile: 'Mobile',
      Address: 'Adresse',
      CardNumber: {
        title: 'Numéro de carte',
        placeholder: '1234 1234 1234 1234'
      },
      CardExpiry: {
        title: 'Exp date',
        placeholder: 'year / month'
      },
      CardCvc: {
        title: 'CVC',
        placeholder: 'CVC'
      },
      Country: 'Pays',
      PostalCode: 'Code Postal',
      City: 'Ville',
      CustomCity: 'Ville personnalisée',
      Region: {
        title: 'Région',
        select: 'Sélectionnez votre région'
      },
      CustomRegion: {
        title: 'Région personnalisée',
        select: 'Sélectionnez votre région personnalisée'
      },
      Email: 'Adresse électronique (facultatif)'
    },
    Qt: 'Quantité',
    // terms of service
    TermOfServiceSubTitle: 'Veuillez lire nos conditions de service ici.',
    PrivacyPolicySubTitle: 'votre vie privée est notre préoccupation s’il vous plaît lire notre politique de confidentialité ici.',
    /*PrivacyPolicyContent: privacyPolicyFr,*/
    ShippingAndReturnSubTitle: 'si vous avez un produit que vous souhaitez retourner ou connaître notre procédure d’expédition, veuillez lire notre politique ici.',
    //contact us
    ContactSubtitle: 'On fait de notre mieux pour répondre à tous nos clients en moins de 24h. Si vous avez des questions, ' + 'veuillez nous contacter à partir de ce formulaire. Ou vous pouvez nous envoyer un e-mail à : <strong>{domain}</strong> ' + 'Si vous nous contactez au sujet de votre commande, veuillez mentionner votre numéro de commande ou le nom complet de l\'acheteur dans votre message.',
    ContactForm: {
      Name: 'Nom',
      Subject: 'Sujet',
      Email: 'Adresse électronique',
      Content: 'Contenu'
    },
    SendBtn: 'Envoyer',
    UpsellAttention: 'ATTENTION C’est une offre unique!',
    SpecialOffer: 'Offre spéciale',
    UpsellP1: '<strong>{discount} de réduction aux nouveaux clients</strong>',
    UpsellP2: 'Nous avons bien reçu votre commande et nous voulons vous remercier et vous souhaiter la bienvenue parmis nos clients.',
    UpsellP3: 'Nous offrons une généreuse remise de <strong>{discount}</strong> à nos nouveaux clients',
    UpsellP4: 'Si vous ajoutez un autre article à votre commande, vous pouvez l\'obtenir à <strong>{discount} de réduction</strong>',
    UpsellP5: 'Le prix de 1 <strong>{offerName}</strong> supplémentaire est à <strong>{offerSalePrice} {offerSalePricePrefix}</strong> Vous pouvez en ajouter 1 ou plus à votre commande à ce prix.',
    UpsellP6: '<strong>Pouvez-vous accepter cette offre spéciale ?</strong>',
    Price: 'Prix',
    YesConfirm: 'Oui! Ajouter à ma commande',
    NoConfirm: 'Non, Ne m\'intéresse pas',
    PayOnDelivery: 'Paiement en espèces à la livraison',
    CrossSellP1: '<strong>{discount} de réduction aux nouveaux clients</strong>',
    CrossSellP2: 'Nous avons bien reçu votre commande et nous souhaitons vous <strong>proposer un autre produit</strong> ' + 'qui pourrait également <strong>vous intéresser</strong>, surtout à <strong>ce prix réduit</strong>!',
    CrossSellP3: '<strong>Nous offrons une généreuse remise de {discount} à nos nouveaux clients</strong>',
    CrossSellP4: 'Si vous ajoutez <strong>{offerName}</strong> à votre commande, vous pouvez l\'obtenir à <strong>{discount} de réduction</strong>',
    CrossSellP5: 'Le prix réduit de <strong>{discount}</strong> n\'est que de <strong>{salePrice} {currency}</strong> ' + 'Vous pouvez en ajouter 1 ou plus à votre commande à ce prix',
    CrossSellP6: '<strong>Can you accept this special offer ?</strong>',
    WhatHowItWorks: 'C’est quoi? Et comment ça marche?',
    UpsellWarrantyP1: '<strong>Obtenez une garantie prolongée d\'un an</strong>',
    UpsellWarrantyP2: 'Nos produits sont couverts par une <strong>garantie de 30 jours</strong>, mais vous pouvez désormais l\'étendre à <strong>1 an de garantie</strong>.',
    UpsellWarrantyP3: 'Si le produit ne fonctionne plus, nous vous en enverrons un nouveau gratuitement!',
    UpsellWarrantyP4: '<strong>Ayez l\'esprit tranquille en prolongeant votre garantie</strong>',
    UpsellWarrantyP5: 'Le prix de la garantie 1 an n\'est que de <strong>{salePrice} {currency}</strong>',
    UpsellWarrantyP6: '<strong>Pouvez-vous accepter cette offre spéciale ?</strong>',
    ThankYou: 'Merci',
    ThankYouP1: 'Nous avons bien reçu votre commande, et voici vos articles achetés :',
    PurchasedItems: '<strong>Articles achetés</strong>',
    Total: 'Total',
    MissingInfoText: 'S\'il manque des informations dans vos informations de livraison, vous pouvez les corriger maintenant ',
    SaveConfirm: 'Enregistrer et confirmer',
    OrderCongratulation: 'Félicitations! nous vous avons enregistré des informations, nous vous appellerons très bientôt pour confirmer votre commande',
    AboutOrderShipping: 'Avant d\'expédier votre commande, nous vous appellerons aujourd\'hui ou demain pour confirmer votre livraison, veuillez vous assurer que votre numéro de téléphone mobile est correct.',
    DeliveryTime: 'Délai de livraison: 2 à 5 jours, Paiement en espèces à la livraison',
    ProductImage: 'image du produit',
    ProductName: 'Nom du produit',
    OrderNow: 'Acheter',
    PayByCashOnDelivery: 'Payer en espèces à la livraison',
    NoOfferInDomain: 'Désolé! Aucune offre dans ce domaine',
    CheckoutValidationError: 'Veuillez compléter vos informations.',
    WhatsUpHiMessage: 'Bonjour, svp plus d’infos sur : {page_name} : {page_url}'
  },
  es: {
    // validation
    Validation: {
      required: '{field} is required.',
      min: {
        string: '{field} must be at least {min} characters.',
        numeric: '{field} must be at least {min}'
      },
      max: {
        string: '{field} must not be greater that {max} characters.',
        numeric: '{field} must not be greater that {max}.'
      },
      numeric: '{field} must be a number.',
      email: '{field} must be an email.',
      digits_between: '{field} must be between {min} and {max} digits.',
      between: {
        string: '{field} must be between {min} and {max} characters.',
        numeric: '{field} must be between {min} and {max}.'
      }
    },
    // header
    Home: 'Home',
    Products: 'Productos',
    TermsOfService: 'Términos de servicio',
    PrivacyPolicy: 'Política de privacidad',
    ShippingAndReturn: 'Envío y devolución',
    FAQ: 'FAQ',
    About: 'Sobre nosotros',
    Contact: 'Contacto',
    ContactUs: 'Contacta con nosotras',
    Refund: 'Reembolso',
    FaqContent: [{
      FaqQuestion: '¿CÓMO PUEDO SEGUIR MIS PEDIDOS Y PAGOS? ',
      FaqAnswer: 'Le enviaremos el número de seguimiento por correo electrónico inmediatamente después de enviar su pedido.'
    }, {
      FaqQuestion: '¿Y SI NECESITO DEVOLVER EL PRODUCTO? ',
      FaqAnswer: '¡No se preocupe! Contáctanos lo antes posible en los primeros 7 días posteriores a la recepción ' + 'de tu pedido y te ayudaremos a procesar la devolución y el reembolso o cambio.'
    }, {
      FaqQuestion: '¿CUÁNTO TIEMPO TARDE EN RECIBIR MI PEDIDO?',
      FaqAnswer: 'Su pedido se entregará dentro de los 5-8 días posteriores a la confirmación del pedido, dependiendo del volumen de pedidos recibidos.<br>' + 'Si hay algún retraso en la recepción de su pedido, comuníquese con nosotros y lo ayudaremos a confirmar el estado de su pedido.'
    }, {
      FaqQuestion: '¿QUÉ POSIBILIDADES DE PAGO ?',
      FaqAnswer: 'Puedes pagar con tarjeta online, o Contra Reembolso dependiendo del producto. La transacción es 100% segura y no guardamos la información de su tarjeta.'
    }, {
      FaqQuestion: '¿QUÉ PASA SI MI ENTREGA SE DAÑA O SE PIERDE?',
      FaqAnswer: 'Nos tomamos estos problemas muy en serio y los trataremos caso por caso. Para obtener más información sobre nuestra política de cambio y reembolso,' + '[<a class="font-weight-bold" href="shipping-return-policy">haga clic aquí</a>].'
    }],
    // AboutUsContent: aboutContentEs,
    // RefundContent: refundPolicyEs,
    // ShippingAndReturnContent: returnAndShipContentEs,
    // TermOfServiceContent: termsOfServiceEs,
    LegalPages: 'Páginas legales',
    Informations: 'Informaciones',
    HomePageMain: {
      FirstLine: '¡Increíble experiencia de compra en línea!',
      Bullets: {
        BulletOne: 'Productos de alta calidad',
        BulletTwo: 'Descuentos increibles',
        BulletThree: 'Entrega rápida'
      },
      SecondLine: '¡No lo dudes! Te encantarán nuestros productos',
      ShopNowBtn: 'Descubre nuestros productos'
    },
    NoOfferInYourCountry: '¡Lo siento! Aún no hay ofertas en {country}',
    HomePageAboutUs: {
      Title: 'Sobre nosotros',
      Content: '{store_name} es una tienda online en {country_name} especializada en productos y complementos ' + 'innovadores que harán tu día a día más fácil y divertido.' + 'Hacemos todo lo posible para brindar soporte de calidad y tiempos de envío más rápidos a nuestros clientes. Nos comprometemos a procesar sus pedidos en menos de 24 horas y a responder a todas sus preguntas a tiempo.' + 'Nos complace darle la bienvenida a nuestra tienda, no dude en realizar pedidos en cualquier momento :) Su satisfacción es nuestra prioridad.'
    },
    HomePageAmazingDelivery: {
      Title: 'Experiencia de entrega satisfactoria',
      Content: 'Puede realizar su pedido en nuestra tienda con tranquilidad, nos asociamos con los mejores mensajeros de {country} para brindarle un tiempo de entrega rápido de 2 a 5 días, y un método de pago seguro mediante contrarrembolso.'
    },
    HomePageSatisfaction: {
      Title: 'Garantía de satisfacción del 100%',
      Content: {
        Text: 'Ofrecemos envío gratuito en todos los productos y le damos 30 días de garantía, para probar tranquilamente su compra.',
        Figures: {
          FigureOne: 'Envío gratis',
          FigureTwo: 'Sitio de confianza',
          FigureThree: 'Pago seguro',
          FigureFour: 'Atención al cliente rápida'
        }
      }
    },
    HomePageDoYouHaveQuestion: {
      Title: '¿Tienes otras preguntas?',
      Content: 'Visite la página de contacto y envíenos su mensaje. Hacemos nuestro mejor esfuerzo para responder a todos nuestros clientes en menos de 24 horas.'
    },
    HomePageFooter: {
      PaymentByCash: 'Pago contra reembolso',
      FreeShipping: '<strong>Envío gratuito y entrega rápida <span class="font-weight-bold" style="white-space: nowrap">( 2 a 5 días )</span><strong>',
      SecurePayment: 'Pago seguro'
    },
    DiscoverOurProducts: 'Descubra nuestros productos',
    // footer
    CopyRight: 'Copyright © 2020-2021 {brand_name}.</br> Todos los derechos reservados',
    ContactSubtitle: 'Hacemos todo lo posible para responder a todos nuestros clientes en menos de 24 horas. ' + 'Si tiene alguna pregunta, comuníquese con nosotros desde este formulario. O puede enviarnos un correo electrónico a: <strong>{domain}</strong> ' + 'Si tienes preguntas acerca de su pedido, mencione su número de pedido o el nombre completo del comprador en su mensaje.',
    FooterDesc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur consequatur impedit incidunt ipsam " + "molestias repellat repellendus sequi tempora. Asperiores beatae consectetur delectus eius error eveniet " + "explicabo, fugiat illo ipsa, minus molestiae non pariatur quasi quo ullam voluptatem voluptates? Ad adipisci" + "consequuntur debitis eaque eveniet ex molestias, odio sapiente! In, quaerat.",
    StepOne: 'Paso 1:',
    SelectQuantity: 'Seleccionar la cantidad',
    TotalPrice: 'Precio total',
    StepTwo: 'Paso 2:',
    StepThree: 'Paso 3:',
    StepThreeText: 'Información de pago',
    DeliveryInfo: 'Información de entrega en <strong>{country}</strong>',
    HowManyUnits: {
      title: 'Para ordenar, por favor agregue su información.',
      subtitle: ' Comprar más para Ahorrar más !'
    },
    OrderForm: {
      title: 'Tarjeta',
      FullName: 'Nombre',
      Mobile: 'Móvil',
      Address: 'Dirección',
      CardNumber: {
        title: 'Número de tarjeta',
        placeholder: '1234 1234 1234 1234'
      },
      CardExpiry: {
        title: 'Exp date',
        placeholder: 'AA / MM'
      },
      CardCvc: {
        title: 'CVC',
        placeholder: 'CVC'
      },
      Country: 'País',
      PostalCode: 'Código Postal',
      CustomCity: 'Ciudad personalizada',
      CustomRegion: {
        title: 'Región personalizada',
        select: 'Seleccione su región personalizada'
      },
      City: 'Ciudad',
      Region: {
        title: 'Región',
        select: 'Seleccione su región'
      },
      Email: 'Correo (optativo)'
    },
    Qt: 'Cantidad',
    // terms of service
    TermOfServiceSubTitle: 'Por favor, lea nuestros términos de servicio aquí.',
    PrivacyPolicySubTitle: 'su privacidad es nuestra preocupación por favor lea nuestra política de privacidad aquí.',
    /*PrivacyPolicyContent: privacyPolicyEs,*/
    // shipping and return
    ShippingAndReturnSubTitle: 'si usted tiene un producto que desea devolver o saber acerca de nuestro procedimiento de envío, por favor lea nuestra política aquí.',
    //contact us
    ContactForm: {
      Name: 'Nombre',
      Subject: 'Asunto',
      Email: 'Correo',
      Content: 'Contenido'
    },
    SendBtn: 'Enviar',
    UpsellAttention: '¡Atención! ¡Esta es una oferta única!',
    SpecialOffer: 'Oferta especial',
    UpsellP1: '<strong>{discount} de descuento a nuestros nuevos clientess</strong>',
    UpsellP2: 'Hemos recibido su pedido y queremos agradecerle y darle la bienvenida por ser un nuevo cliente..',
    UpsellP3: 'Ofrecemos un generoso descuento del <strong>{discount}</strong> a nuestros nuevos clientes.',
    UpsellP4: 'Si añades otro a tu pedido puedes conseguirlo con <strong>{discount} descuento</strong>',
    UpsellP5: 'El precio de <strong>{offerName}</strong> adicional es de <strong>{offerSalePrice} {offerSalePricePrefix}</strong> Puede agregar 1 o más a su pedido a este precio',
    UpsellP6: '<strong>¿Puedes aceptar esta oferta especial ?</strong>',
    Price: 'Precio',
    YesConfirm: '¡Sí! Añadir a mi pedido',
    NoConfirm: 'No, no me interesa',
    PayOnDelivery: 'Pago en efectivo a la entrega',
    CrossSellP1: '<strong>{discount} de descuento a nuestros nuevos clientes</strong>',
    CrossSellP2: 'Hemos recibido su pedido y queremos <strong>sugerirle otro producto</strong> que también podría ser <strong>' + 'muy interesante</strong> para usted a este <strong>precio rebajado</strong>.',
    CrossSellP3: '<strong>Ofrecemos un generoso descuento del {discount} a nuestros nuevos clientes</strong>',
    CrossSellP4: 'Si añade <strong>{offerName}</strong> a su pedido, puede obtenerlo con <strong>{discount} de descuento</strong>',
    CrossSellP5: 'El precio con descuento de <strong>{offerName}</strong> es de <strong>{salePrice} {currency}</strong>. Puede agregar 1 o más a su pedido a este precio.',
    CrossSellP6: '<strong>¿Puedes aceptar esta oferta especial?</strong>',
    WhatHowItWorks: '¿Qué es esto? ¿Y cómo funciona?',
    UpsellWarrantyP1: '<strong>Obtenga 1 año de garantía extendida</strong>',
    UpsellWarrantyP2: 'Nuestros productos están cubiertos por una <strong>garantía de 30 días</strong>, pero ahora puede extenderla a <strong>año de garantía</strong>.',
    UpsellWarrantyP3: 'Si el producto deja de funcionar, ¡le enviaremos uno nuevo gratis!',
    UpsellWarrantyP4: '<strong>Disfrute de la tranquilidad ampliando su garantía</strong>',
    UpsellWarrantyP5: 'Le prix de la garantie 1 an n\'est que de <strong>{salePrice} {currency}</strong>',
    UpsellWarrantyP6: '<strong>Pouvez-vous accepter cette offre spéciale ?</strong>',
    ThankYou: 'Gracias',
    ThankYouP1: 'Hemos recibido su pedido y estos son sus artículos comprados:',
    PurchasedItems: '<strong>Artículos comprados</strong>',
    Total: 'Total',
    MissingInfoText: 'Si su información de entrega le falta alguna información, puede corregirla ahora',
    SaveConfirm: 'guardar y confirmar',
    OrderCongratulation: '¡Felicitaciones! le hemos guardado la información, le llamaremos muy pronto para confirmar su pedido',
    AboutOrderShipping: 'Antes de enviar su pedido, lo llamaremos hoy o mañana para confirmar su entrega, asegúrese de que su número de teléfono móvil sea correcto.',
    DeliveryTime: 'El tiempo de entrega: 2 a 5 días, Pago contra reembolso',
    ProductImage: 'Imagen del producto',
    ProductName: 'Nombre del producto',
    OrderNow: 'Ordenar ahora',
    PayByCashOnDelivery: 'Pagar contra reembolso',
    NoOfferInDomain: '¡Perdón! No hay ofertas en este dominio',
    CheckoutValidationError: 'Por favor complete su información.',
    WhatsUpHiMessage: 'Hola, por favor cuéntame más sobre : {page_name} : {page_url}'
  },
  ar: {
    // validation
    Validation: {
      required: '{field} مطلوب.',
      min: {
        string: 'يجب أن يكون طول نص {field} على الأقل {min} حروفٍ/حرفًا.',
        numeric: 'يجب أن تكون قيمة حقل {field} مساوية أو أكبر لـ {min}.'
      },
      max: {
        string: 'يجب أن لا يتجاوز طول نص {field} {max} حروفٍ/حرفًا.',
        numeric: 'يجب أن تكون قيمة حقل {field} مساوية أو أصغر لـ {max}.'
      },
      numeric: 'يجب على الحقل {field} أن يكون رقمًا.',
      email: 'يجب أن يكون {field} عنوان بريد إلكتروني صحيح البُنية.',
      digits_between: 'يجب أن يحتوي حقل {field} بين {min} و {max} رقمًا/أرقام',
      between: {
        string: 'يجب أن يكون عدد حروف نص {field} بين {min} و {max}',
        numeric: 'يجب أن تكون قيمة {field} بين {min} و {max}.'
      }
    },
    // header
    Home: 'الصفحة الرئيسية',
    Products: 'منتجات',
    TermsOfService: 'شروط الخدمة',
    PrivacyPolicy: 'سياسة الخصوصية',
    ShippingAndReturn: 'الشحن والارجاع',
    FAQ: 'الأسئلة المتداولة',
    Contact: 'الاتصال',
    ContactUs: 'اتصل بنا',
    About: 'معلومات عنا',
    Refund: 'استرداد',
    // AboutUsContent: aboutContentAr,
    FaqContent: [{
      FaqQuestion: 'كيف يمكنني متابعة  مشترياتي؟',
      FaqAnswer: 'سوف نرسل رقم التتبع عن طريق البريد الإلكتروني مباشرة بعد شحن طلبك.'
    }, {
      FaqQuestion: 'ماذا لو كنت بحاجة إلى إعادة المنتج؟',
      FaqAnswer: 'لا تقلق! اتصل بنا في أقرب وقت ممكن في أول 7 أيام من استلام طلبك ، وسنساعدك في معالجة الإرجاع والاسترداد أو الاستبدال.'
    }, {
      FaqQuestion: 'ما هي المدة التي يستغرقها الحصول على طلبي؟',
      FaqAnswer: 'سيتم تسليم طلبك في غضون 2-5 أيام من تأكيد الطلب ، اعتمادًا على حجم الطلبات المستلمة<br>' + 'إذا كان هناك أي تأخير في استلام طلبك ، فيرجى الاتصال بنا وسنساعدك في تأكيد حالة طلبك.'
    }, {
      FaqQuestion: 'ما هي إمكانيات الدفع ؟',
      FaqAnswer: 'يمكنكم الدفع نقدًا أو بالبطاقة عند الاستلام.'
    }, {
      FaqQuestion: 'ماذا يحدث إذا تضررت مشترياتي أو فقدت؟ ',
      FaqAnswer: 'نحن نأخذ هذه القضايا على محمل الجد وسنتعامل معها على أساس كل حالة على حدة.' + ' لمزيد من المعلومات حول سياسة الإرجاع والاسترداد ، يرجى مراجعة هذه <a class="font-weight-bold" href="shipping-return-policy">الصفحة</a> .'
    }],
    LegalPages: 'الصفحات القانونية',
    Informations: 'معلومات',
    HomePageMain: {
      FirstLine: 'تجربة تسوق مذهلة عبر الإنترنت!',
      Bullets: {
        BulletOne: 'منتجات ذات جودة عالية',
        BulletTwo: 'تخفيضات كبيرة',
        BulletThree: 'توصيل سريع'
      },
      SecondLine: 'لا تتردد! سوف تحب منتجاتنا',
      ShopNowBtn: 'اكتشف منتجاتنا'
    },
    NoOfferInYourCountry: 'آسف! لا توجد عروض في {country} حتى الآن',
    HomePageAboutUs: {
      Title: 'معلومات عنا',
      Content: '{store_name} هو متجر على الإنترنت في {country_name} متخصص في المنتجات والإكسسوارات المبتكرة التي ستجعل حياتك اليومية أسهل وأكثر متعة' + 'نبذل قصارى جهدنا لتقديم دعم في المستوى ،' + ' وأوقات شحن أسرع لعملائنا. نعدك بمعالجة طلباتك في أقل من 24 ساعة ، والإجابة على جميع أسئلتك في الوقت المحدد.' + 'يسعدنا أن نرحب بكم في متجرنا ، ولا تتردد في تقديم الطلبات في أي وقت :) رضاك هو هدفنا.'
    },
    HomePageAmazingDelivery: {
      Title: 'تجربة شراء ممتعة',
      Content: 'يمكنك وضع طلبك في متجرنا براحة البال ، فقد عقدنا شراكة مع أفضل شركات الشحن في {country} لنوفر لك شحن سريع من 2 إلى 5 أيام ، وطريقة دفع آمنة نقدًا عند الإستلام.'
    },
    HomePageSatisfaction: {
      Title: 'رضاكم هو هدفنا',
      Content: {
        Text: 'نقدم شحنًا مجانيًا لجميع المنتجات ، ونمنحك 30 يومًا من الضمان لاختبار المنتج بكل راحة',
        Figures: {
          FigureOne: 'الشحن مجانا',
          FigureTwo: 'موقع موثوق',
          FigureThree: 'شراء آمن',
          FigureFour: 'دعم عملاء سريع'
        }
      }
    },
    HomePageDoYouHaveQuestion: {
      Title: 'هل لديك أسئلة أخرى؟',
      Content: 'قم بزيارة صفحة التواصل، وأرسل لنا رسالتك. سوف نبذل قصارى جهدنا للإجابة على جميع عملائنا في أقل من 24 ساعة'
    },
    HomePageFooter: {
      PaymentByCash: 'الدفع نقدا عند الاستلام',
      FreeShipping: '<strong> الشحن المجاني والتسليم السريع <span class="font-weight-bold" style="white-space: nowrap">( من 2 إلى 5 أيام )</span></strong>',
      SecurePayment: '<strong>دفع امن</strong>'
    },
    DiscoverOurProducts: 'اكتشف منتجاتنا',
    // footer
    CopyRight: 'حقوق الطبع والنشر © 2020-2021 {brand}. جميع الحقوق محفوظة',
    FooterDesc: 'كن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد الألم نشأت بالفعل، وسأعرض لك التفاصيل لتكتشف حقيقة وأساس تلك السعادة البشرية' + '، فلا أحد يرفض أو يكره أو يتجنب الشعور بالسعادة، ولكن بفضل هؤلاء الأشخاص الذين لا يدركون بأن السعادة لا بد ' + 'أن نستشعرها بصورة أكثر عقلانية ومنطقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في ' + 'الحب ونيل المنال ويتلذذ بالآلام، الألم هو الألم ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.',
    ContactSubtitle: 'نبذل قصارى جهدنا للإجابة على جميع عملائنا في أقل من 24 ساعة. ' + 'إذا كان لديك أي أسئلة ، يرجى الاتصال بنا من هذا النموذج. أو يمكنك مراسلتنا على البريد الإلكتروني: <strong>{domain}</strong> ' + 'إذا كانت لديك أسئلة حول طلبك ، فيرجى ذكر رقم الطلب أو الاسم الكامل للمشتري في رسالتك.',
    StepOne: 'الخطوة الأولى:',
    SelectQuantity: 'تحديد الكمية',
    TotalPrice: 'السعر الإجمالي',
    StepTwo: 'الخطوة الثانية:',
    StepThree: 'الخطوة 3:',
    StepThreeText: 'معلومات الدفع',
    DeliveryInfo: 'معلومات التسليم في <strong>{country}</strong>',
    HowManyUnits: {
      title: 'للطلب، يرجى إضافة معلوماتك.',
      subtitle: ' اشتري المزيد لتوفير المزيد !'
    },
    OrderForm: {
      title: 'البطاقة',
      FullName: 'الإسم الكامل',
      Mobile: 'الجوال',
      Address: 'العنوان',
      CardNumber: {
        title: 'رقم البطاقة',
        placeholder: '1234 1234 1234 1234'
      },
      CardExpiry: {
        title: 'إنتهاء الصلاحية',
        placeholder: 'سنة / شهر'
      },
      CardCvc: {
        title: 'CVC',
        placeholder: 'CVC'
      },
      Country: 'البلد',
      PostalCode: 'الرمز البريدي',
      CustomCity: 'مدينة مخصصة',
      CustomRegion: {
        title: 'المنطقة المخصصة',
        select: 'حدد منطقتك المخصصة'
      },
      City: 'المدينة',
      Region: {
        title: 'المنطقة',
        select: 'حدد منطقتك'
      },
      Email: 'البريد الإلكتروني (اختياري)'
    },
    Qt: 'الكمية',
    // terms of service
    TermOfServiceSubTitle: 'يرجى قراءة شروط الخدمة هنا.',
    // TermOfServiceContent: termsOfServiceAr,
    PrivacyPolicySubTitle: 'خصوصيتك هي قلقنا يرجى قراءة سياسة الخصوصية لدينا هنا.',
    /*PrivacyPolicyContent: privacyPolicyAr,*/
    ShippingAndReturnSubTitle: 'إذا كان لديك منتج تريد إرجاعه أو معرفة إجراءات الشحن لدينا، يرجى قراءة سياستنا هنا.',
    // ShippingAndReturnContent: returnAndShipContentAr,
    // RefundContent: refundPolicyAr,
    //contact us
    //ContactSubtitle: 'لا تتردد في الاتصال بنا',
    ContactForm: {
      Name: 'اسم',
      Subject: 'الموضوع',
      Email: 'البريد الإلكتروني',
      Content: 'المحتوى'
    },
    SendBtn: 'ارسال',
    UpsellAttention: 'انتباه! هذا عرض لمرة واحدة!',
    SpecialOffer: 'عرض خاص',
    UpsellP1: '<strong>تخفيض {discount} لعملائنا الجدد</strong>',
    UpsellP2: 'لقد تلقينا طلبك ونريد أن نشكرك ونرحب بك لكونك زبون جديد.',
    UpsellP3: 'نقدم خصمًا سخيًا بنسبة <strong>{discount}</strong> لكل زبون جديد',
    UpsellP4: 'إذا قمت بإضافة واحد آخر إلى طلبك يمكنك الحصول عليه <strong/>بتخفيض {discount}<strong>',
    UpsellP5: 'سعر <strong>{offerName}</strong> الإضافي هو <strong>{offerSalePricePrefix} {offerSalePrice}</strong> فقط! يمكنك إضافة 1 أو أكثر إلى طلبك بهذا السعر',
    UpsellP6: '<strong>هل يمكنك قبول هذا العرض الخاص؟</strong>',
    Price: 'الثمن',
    YesConfirm: 'نعم! أضف إلى طلبي',
    NoConfirm: 'لا، لست مهتما',
    PayOnDelivery: 'الدفع نقدا عند التسليم',
    CrossSellP1: '<strong>تخفيض {discount} لعملائنا الجدد</strong>',
    CrossSellP2: 'قد تلقينا طلبك ونريد <strong>اقتراح منتج آخر</strong> قد يكون أيضًا <strong>مثيرًا للاهتمام</strong> بالنسبة لك <strong>بهذا السعر المخفض</strong>.',
    CrossSellP3: '<strong>نقدم تخفيضًا سخيًا بنسبة {discount} لعملائنا الجدد</strong>',
    CrossSellP4: 'إذا قمت بإضافة <strong>{offerName}</strong> إلى طلبك ، يمكنك الحصول عليه بتخفيض <strong>{discount}</strong>',
    CrossSellP5: 'السعر المخفض لـ <strong>{offerName}</strong> هو <strong>{currency} {salePrice}</strong> فقط. يمكنك إضافة 1 أو أكثر إلى طلبك بهذا السعر',
    CrossSellP6: '<strong>هل يمكنك قبول هذا العرض الخاص؟</strong>',
    WhatHowItWorks: 'ما هذا وكيف يعمل ؟',
    UpsellWarrantyP1: '<strong>احصل على ضمان ممتد لمدة عام (12 شهر)</strong>',
    UpsellWarrantyP2: 'منتجاتنا مغطاة <strong>بضمان 30 يومًا</strong> ، ولكن يمكنك الآن تمديده إلى ضمان <strong>لمدة عام (12 شهر)</strong>.',
    UpsellWarrantyP3: 'إذا توقف المنتج عن العمل ، فسوف نرسل لك منتجًا جديدًا مجانًا!',
    UpsellWarrantyP4: '</strong>احصل على راحة البال من خلال تمديد الضمان الى 12 شهر<strong>',
    UpsellWarrantyP5: 'سعر الضمان لمدة عام هو <strong>{salePrice} {currency}<strong/> فقط',
    UpsellWarrantyP6: '</strong>هل يمكنك قبول هذا العرض الخاص ؟<strong>',
    ThankYou: 'شكرا لك',
    ThankYouP1: 'لقد استلمنا طلبك ، وهنا المنتوجات التي اشتريتها:',
    PurchasedItems: '<strong>المنتوجات</strong>',
    Total: 'المجموع',
    MissingInfoText: 'إذا كانت معلومات التوصيل الخاصة بك تفتقد إلى بعض المعلومات ، فيمكنك تصحيحها الآن',
    SaveConfirm: 'حفظ وتأكيد',
    OrderCongratulation: 'مبروك! لقد حفظنا لك المعلومات، وسوف نتصل بكم في وقت قريب جدا لتأكيد الطلب',
    AboutOrderShipping: 'قبل شحن طلبك ، سوف نتصل بك اليوم أو غدًا لتأكيد طلبك ، يرجى التأكد من صحة رقم هاتفك المحمول.',
    DeliveryTime: 'موعد التوصيل: من 2 إلى 5 أيام ، الدفع نقدًا عند الاستلام',
    ProductImage: 'صورة المنتج',
    ProductName: 'اسم المنتج',
    OrderNow: 'اطلب الان',
    PayByCashOnDelivery: 'الدفع نقدا عند الاستلام',
    NoOfferInDomain: 'نعتذر! لا توجد عروض في هذا المجال',
    CheckoutValidationError: 'يرجى استكمال المعلومات الخاصة بك.',
    WhatsUpHiMessage: 'السلام عليكم، من فضلك اخبرني المزيد عن : {page_name} : {page_url}'
  },
  it: {
    // validation
    Validation: {
      required: '{field} is required.',
      min: {
        string: '{field} must be at least {min} characters.',
        numeric: '{field} must be at least {min}'
      },
      max: {
        string: '{field} must not be greater that {max} characters.',
        numeric: '{field} must not be greater that {max}.'
      },
      numeric: '{field} must be a number.',
      email: '{field} must be an email.',
      digits_between: '{field} must be between {min} and {max} digits.',
      between: {
        string: '{field} must be between {min} and {max} characters.',
        numeric: '{field} must be between {min} and {max}.'
      }
    },
    // header
    Home: 'Home',
    Products: 'Prodotti',
    TermsOfService: 'Termini e Condizioni',
    PrivacyPolicy: 'Informativa Sulla Privacy',
    ShippingAndReturn: 'Spedizione e Resi',
    FAQ: 'FAQ',
    About: 'Chi siamo',
    Refund: 'Rimborso',
    Contact: 'Contatto',
    ContactUs: 'Contattaci',
    // AboutUsContent: aboutContentIt,
    // RefundContent: refundPolicyIt,
    // TermOfServiceContent: termsOfServiceIt,
    FaqContent: [{
      FaqQuestion: 'COME POSSO SEGUIRE I MIEI ORDINI E PAGAMENTI?﻿',
      FaqAnswer: 'Invieremo il numero di tracciamento via e-mail subito dopo la spedizione dell\'ordine.'
    }, {
      FaqQuestion: 'E SE DEVO RESTITUIRE IL PRODOTTO?﻿',
      FaqAnswer: 'Non preoccuparti! Contattaci il prima possibile nei primi 7 giorni dalla ricezione del tuo ordine e ti ' + 'aiuteremo a elaborare il reso e il rimborso o il cambio.'
    }, {
      FaqQuestion: 'QUANTO TEMPO SERVE PER RICEVERE IL MIO ORDINE?﻿',
      FaqAnswer: 'Il tuo ordine verrà consegnato entro 5-8 giorni dalla conferma dell\'ordine, a seconda del volume degli ordini ricevuti.<br>' + 'In caso di ritardo nella ricezione del tuo ordine, ti preghiamo di contattarci e ti aiuteremo a confermare lo stato del tuo ordine.'
    }, {
      FaqQuestion: 'QUALI POSSIBILITÀ DI PAGAMENTO ?﻿',
      FaqAnswer: 'Puoi pagare con carta online o in contrassegno a seconda del prodotto. La transazione è sicura al 100% e non salviamo i dati della tua carta.'
    }, {
      FaqQuestion: 'COSA SUCCEDE SE LA MIA CONSEGNA È DANNEGGIATA O SMARRITA?﻿',
      FaqAnswer: 'Prendiamo questi problemi molto sul serio e li affronteremo caso per caso. ' + 'Per ulteriori informazioni sulla nostra politica di cambio e rimborso, per favore ' + '<a class="font-weight-bold" href="shipping-return-policy">clicca qui</a>.'
    }],
    /*PrivacyPolicyContent: privacyPolicyIt,*/
    // ShippingAndReturnContent: returnAndShipContentIt,
    LegalPages: 'Pagine legali',
    Informations: 'Informazioni',
    HomePageMain: {
      FirstLine: 'Incredibile esperienza di acquisto online!',
      Bullets: {
        BulletOne: 'Prodotti di alta qualità',
        BulletTwo: 'Sconti incredibili',
        BulletThree: 'Consegna veloce'
      },
      SecondLine: 'Non esitare! Amerai i nostri prodotti',
      ShopNowBtn: 'Scopri i nostri prodotti'
    },
    NoOfferInYourCountry: 'Scusa! Ancora nessuna offerta in {country}',
    HomePageAboutUs: {
      Title: 'CHI SIAMO',
      Content: '{store_name} è un negozio online in {country_name} specializzato in prodotti e accessori innovativi che ' + 'renderanno la tua vita quotidiana più facile e molto più divertente.' + 'Facciamo del nostro meglio per fornire un supporto di qualità e tempi di spedizione più rapidi ai ' + 'nostri clienti. Promettiamo di elaborare i tuoi ordini in meno di 24 ore e di rispondere a tutte le tue domande in tempo.' + 'Siamo felici di darti il benvenuto nel nostro negozio, siamo liberi di effettuare ordini in ' + 'qualsiasi momento :) La tua soddisfazione è il nostra priorità.'
    },
    HomePageAmazingDelivery: {
      Title: 'Esperienza di consegna soddisfacente',
      Content: 'Puoi effettuare l\'ordine nel nostro negozio in tutta tranquillità, abbiamo collaborato con i migliori ' + 'corrieri in {country} per fornirti tempi di consegna rapidi da 2 a 5 giorni e metodo di pagamento sicuro con contrassegno.'
    },
    HomePageSatisfaction: {
      Title: 'Garanzia di soddisfazione al 100%',
      Content: {
        Text: 'Offriamo la spedizione gratuita su tutti i prodotti e ti diamo 30 giorni di garanzia per testare il prodotto',
        Figures: {
          FigureOne: 'Spedizione gratuita',
          FigureTwo: 'Sito affidabile',
          FigureThree: 'Pagamento sicuro',
          FigureFour: 'Assistenza clienti veloce'
        }
      }
    },
    HomePageDoYouHaveQuestion: {
      Title: 'Hai altre domande?',
      Content: 'Visita la pagina dei contatti e inviaci il tuo messaggio. Facciamo del nostro meglio per rispondere a tutti i nostri clienti in meno di 24H'
    },
    HomePageFooter: {
      PaymentByCash: 'Pagamento in Contrassegno',
      FreeShipping: '<strong>Spedizione gratuita e veloce <span class="font-weight-bold" style="white-space: nowrap">( da 2 a 5 giorni )</span></strong>',
      SecurePayment: 'Pagamento sicuro'
    },
    DiscoverOurProducts: 'Scopri i nostri prodotti',
    // footer
    CopyRight: 'Copyright © 2020-2021 {brand_name}.</br> Tutti i diritti riservati',
    FooterDesc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur consequatur impedit incidunt ipsam " + "molestias repellat repellendus sequi tempora. Asperiores beatae consectetur delectus eius error eveniet " + "explicabo, fugiat illo ipsa, minus molestiae non pariatur quasi quo ullam voluptatem voluptates? Ad adipisci" + "consequuntur debitis eaque eveniet ex molestias, odio sapiente! In, quaerat.",
    StepOne: 'Punto 1:',
    SelectQuantity: 'Seleziona la quantità',
    TotalPrice: 'Prezzo totale',
    StepTwo: 'Punto 2:',
    StepThree: 'Punto 3:',
    StepThreeText: 'Informazioni di pagamento',
    DeliveryInfo: 'Informazioni sulla consegna <strong>{country}</strong>',
    HowManyUnits: {
      title: 'Per ordinare, si prega di aggiungere le proprie informazioni.',
      subtitle: 'Compra di più per Risparmia di più'
    },
    OrderForm: {
      title: 'Carta',
      FullName: 'nome e cognome',
      Mobile: 'Mobile',
      Address: 'Indirizzo',
      CardNumber: {
        title: 'Numero di carta',
        placeholder: '1234 1234 1234 1234'
      },
      CardExpiry: {
        title: 'Exp date',
        placeholder: 'AA / MM'
      },
      CardCvc: {
        title: 'CVC',
        placeholder: 'CVC'
      },
      Country: 'Nazione',
      PostalCode: 'Codice postale',
      CustomCity: 'Città personalizzata',
      CustomRegion: {
        title: 'Regione personalizzata',
        select: 'Seleziona la tua regione personalizzata'
      },
      City: 'Città',
      Region: {
        title: 'Regione',
        select: 'Seleziona la tua regione'
      },
      Email: 'Email (facoltativo)'
    },
    Qt: 'Quantità',
    // terms of service
    TermOfServiceSubTitle: 'si prega di leggere le nostre condizioni di servizio qui.',
    PrivacyPolicySubTitle: 'la tua privacy è la nostra preoccupazione leggi la nostra politica sulla privacy qui.',
    ShippingAndReturnSubTitle: 'se si dispone di un prodotto che si desidera restituire o conoscere la nostra procedura di spedizione, si prega di leggere la nostra politica qui.',
    //contact us
    ContactSubtitle: 'Facciamo del nostro meglio per rispondere a tutti i nostri clienti in meno di 24 ore. ' + 'Se hai domande, contattaci da questo modulo. Oppure puoi inviarci un\'e-mail a: <strong>{domain}</strong> ' + 'Se ci stai contattando per il tuo ordine, indica il numero dell\'ordine o il nome completo dell\'acquirente nel messaggio.',
    ContactForm: {
      Name: 'Nome',
      Subject: 'Oggetto',
      Email: 'Email',
      Content: 'Contenuto'
    },
    SendBtn: 'Invia',
    UpsellAttention: 'Attenzione! Questa è un\'offerta unica!',
    SpecialOffer: 'Offerta speciale',
    UpsellP1: '<strong>{discount} di sconto ai nostri nuovi clienti</strong>',
    UpsellP2: 'Abbiamo ricevuto il tuo ordine e ti ringraziamo e ti diamo il benvenuto per essere un nuovo cliente.',
    UpsellP3: 'Offriamo uno sconto generoso del <strong>{discount}</strong> ai nostri nuovi clienti',
    UpsellP4: 'Se ne aggiungi un altro al tuo ordine puoi ottenerlo con <strong>uno sconto del {discount}</strong>',
    UpsellP5: 'Il prezzo di <strong>{offerName}<strong> aggiuntivo è di soli <strong>{offerSalePricePrefix} {offerSalePrice}</strong> Puoi aggiungere 1 o più al tuo ordine a questo prezzo',
    UpsellP6: '<strong>Puoi accettare questa offerta speciale ?</strong>',
    Price: 'Prezzo',
    YesConfirm: 'Sì, sì! Aggiungi al mio ordine',
    NoConfirm: 'No, non mi interessa',
    PayOnDelivery: 'Pagamento in contanti alla consegna',
    CrossSellP1: '<strong>{discount} di sconto ai nostri nuovi clienti</strong>',
    CrossSellP2: 'Abbiamo ricevuto il tuo ordine e vogliamo <strong>suggerirti un altro prodotto</strong> che potrebbe essere ' + '<strong>molto interessante</strong> anche per te a questo <strong>prezzo scontato</strong>.',
    CrossSellP3: '<strong>Offriamo un generoso sconto del {discount ai nostri nuovi clienti</strong>',
    CrossSellP4: 'Se aggiungi <strong>{offerName}</strong> al tuo ordine puoi ottenerlo con il <strong>{discount}</strong> di sconto',
    CrossSellP5: 'Il prezzo scontato di <strong>{offerName}</strong> è di <strong>{salePrice} {currency}</strong>. Puoi aggiungere 1 o più al tuo ordine a questo prezzo',
    CrossSellP6: '<strong>Puoi accettare questa offerta speciale?</strong>',
    WhatHowItWorks: 'Che cos’è E come funziona ?',
    UpsellWarrantyP1: '<strong>Ottieni 1 anno di garanzia estesa</strong>',
    UpsellWarrantyP2: 'I nostri prodotti sono coperti da una <strong>garanzia di 30 giorni</strong>, ma ora puoi estenderla a <strong>1 anno di garanzia</strong>.',
    UpsellWarrantyP3: 'Se il prodotto smette di funzionare te ne invieremo uno nuovo gratuitamente!',
    UpsellWarrantyP4: '<strong>Stai tranquillo estendendo la tua garanzia</strong>',
    UpsellWarrantyP5: 'Il prezzo di 1 anno di garanzia è solo <strong>{salePrice} {currency}</strong>',
    UpsellWarrantyP6: '<strong>Puoi accettare questa offerta speciale ?</strong>',
    ThankYou: 'Grazie',
    ThankYouP1: '#Abbiamo ricevuto il tuo ordine ed ecco gli articoli acquistati:',
    PurchasedItems: '<strong>#Articoli acquistati</strong>',
    Total: 'Totale',
    MissingInfoText: 'Se nelle tue informazioni di consegna mancano alcune informazioni, puoi correggerle ora',
    SaveConfirm: 'salva e conferma',
    OrderCongratulation: 'Congratulazioni! vi abbiamo salvato le informazioni, vi chiameremo molto presto per confermare l’ordine',
    AboutOrderShipping: 'Prima di spedire il tuo ordine, ti chiameremo oggi o domani per confermare la consegna, assicurati che il tuo numero di cellulare sia corretto.',
    DeliveryTime: 'Tempi di consegna: da 2 a 5 giorni, Pagamento in contrassegno',
    ProductImage: 'Immagine del prodotto',
    ProductName: 'Nome del prodotto',
    OrderNow: 'ACQUISTA ORA',
    PayByCashOnDelivery: 'Paga in Contrassegno',
    NoOfferInDomain: 'Scusa! Nessuna offerta in questo dominio',
    CheckoutValidationError: 'Per favore completa le tue informazioni.',
    WhatsUpHiMessage: 'Ciao, per favore dimmi di più su : {page_name} : {page_url}'
  }
};